module.exports = __webpack_public_path__ + "2f05a51956049e2419a874258a2906b7.pdf";